import { useQuery } from '@tanstack/react-query';
import { useUserLocale } from '@phoenix/core/frontend/shared/util/locales/use-user-locale';
import { getLocale } from '@phoenix/core/frontend/shared/util/locales/locales';
import { StaticContentApiService } from '@phoenix/core/frontend/shared/domain/static-content/static-content-api.service';

export const useWarrantyExtensionEntry = ({ disabled } = { disabled: false }) => {
  const locale = useUserLocale() || getLocale();
  const { key, fetcher } = StaticContentApiService.getWarrantyExtensionEntryFetcher(
    locale,
    `warranty_extension_${locale.country.toLowerCase()}`
  );
  const { data, isLoading, isError } = useQuery([key], fetcher, { enabled: !disabled && !!locale });

  return {
    legalConditions: data,
    isLoadingConditions: isLoading,
    isGetConditionsError: isError,
  };
};
